// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__20TJU","threesixtyIcon":"threesixtyIcon__1AC7U"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/gemComponentsView/scss/gemComponentsView.scss
// module id = PJ3B
// module chunks = 0